import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../../utils";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

interface SummaryBoxProps {
  title: string;
  total: number;
  unit: string;
  /** Draws the figure in the critical colour, for a deduction such as a credit note. */
  tone?: "error";
}

export default function SummaryBox({ title, total, unit, tone }: Readonly<SummaryBoxProps>) {
  return (
    <Box
      sx={{
        bgcolor: (theme) => theme.palette.primary.main + "1A",
        border: (theme) => `2px solid ${theme.palette.primary.main}`,
        borderRadius: 3,
        p: 1.5,
        [compact]: { p: 1, borderRadius: 2 },
      }}
    >
      <Box display="flex" alignItems="center" flexDirection="column" gap={0.5}>
        <Typography variant="caption" color="primary" fontWeight={700}>
          {title}
        </Typography>
        <Typography color={tone}>
          {unit === "บาท" ? formatNumber(total) : total} {unit}
        </Typography>
      </Box>
    </Box>
  );
}
